import { usePlayVideoState } from 'components/discover/contexts/PlayVideoContext';
import { PublicationItem } from 'components/discover/publications/model';
import { PublicationCategory } from 'components/discover/publications/see-more/model';
import { first } from 'lodash-es';

export type InitialSelection = Readonly<{
  categoryId: number;
  keywordId: number | null;
  videoId: string | null;
  autoPlay: boolean;
}>;

export function useDefaultSelection(
  items: ReadonlyArray<PublicationItem>,
  categories: ReadonlyArray<PublicationCategory>,
): InitialSelection {
  const videoPlayingState = usePlayVideoState();

  if (videoPlayingState?.isPlaying === true) {
    const selectedVideo = items?.find(i => i.videoId === videoPlayingState.played.videoId);

    if (selectedVideo !== undefined) {
      return {
        categoryId: selectedVideo.categoryId!,
        keywordId: selectedVideo.keywordId ?? null,
        videoId: selectedVideo.videoId!,
        autoPlay: true,
      };
    }
  }

  const defaultCategory = first(categories)!;
  return {
    categoryId: defaultCategory.id,
    keywordId: null,
    videoId: null,
    autoPlay: false,
  };
}
